module.exports = __webpack_public_path__ + "media/images/guideline/D01-2bfc40b4c653d2c4afb557f95f8452ea.jpg";